export default __webpack_public_path__ + "static/media/nft-legend.8f0447ed.jpg";